var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCooperMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 0C21.2446 0 22.1984 0.395088 22.9017 1.09835C23.6049 1.80161 24 2.75544 24 3.75V15.75C24 16.7446 23.6049 17.6984 22.9017 18.4016C22.1984 19.1049 21.2446 19.5 20.25 19.5H3.75C2.75544 19.5 1.80161 19.1049 1.09835 18.4016C0.395088 17.6984 0 16.7446 0 15.75V3.75C0 2.75544 0.395088 1.80161 1.09835 1.09835C1.80161 0.395088 2.75544 0 3.75 0H20.25ZM22.5 5.9415L12.381 11.8965C12.2853 11.9527 12.1784 11.9869 12.0679 11.9968C11.9574 12.0066 11.8461 11.9918 11.742 11.9535L11.619 11.8965L1.5 5.9445V15.75C1.5 16.3467 1.73705 16.919 2.15901 17.341C2.58097 17.7629 3.15326 18 3.75 18H20.25C20.8467 18 21.419 17.7629 21.841 17.341C22.2629 16.919 22.5 16.3467 22.5 15.75V5.9415ZM20.25 1.5H3.75C3.15326 1.5 2.58097 1.73705 2.15901 2.15901C1.73705 2.58097 1.5 3.15326 1.5 3.75V4.203L12 10.38L22.5 4.2V3.75C22.5 3.15326 22.2629 2.58097 21.841 2.15901C21.419 1.73705 20.8467 1.5 20.25 1.5Z",
    fill: "#02E2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooperMail);
export default __webpack_public_path__ + "static/media/cooper-mail.b5604ba270b3016bac79cc3a4736c0de.svg";
export { ForwardRef as ReactComponent };